import React from 'react';

interface CaptionOverlayProps {
  text: string;
}

// Split on literal newlines or <br> tags emitted by captionParser when joining
// multi-line cues. Render each segment as plain text so the cue payload cannot
// inject HTML.
const LINE_BREAK = /<br\s*\/?>|\r?\n/i;

export const CaptionOverlay = React.memo(function CaptionOverlay({ text }: CaptionOverlayProps) {
  if (!text) return null;

  const lines = text.split(LINE_BREAK);

  return (
    <div className="kollab-player-caption-container">
      <div
        className="kollab-player-caption-overlay"
        aria-live="polite"
        aria-atomic="true"
      >
        {lines.map((line, i) => (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
});
